import { Button } from '@material-ui/core';
import { PencilSimpleIcon } from '@phosphor-icons/react';
import clsx from 'clsx';
import { FC } from 'react';
import { DIRECTION_ROLE_ID } from '../../shared/constants';
import { readRole } from '../../shared/utils';
import { EDIT_PROFILE_TITLE } from '../constants';
import { useStyles } from '../styles';
import { displayOrMissing, getManagerName } from '../utils';
import ProfileEditForm from './ProfileEditForm';

interface ProfileTabProps {
  user: any;
  editing: boolean;
  roleLabel: string;
  editTitle?: string;
  onStartEdit: () => void;
  onUserUpdated: (updated?: any) => Promise<void> | void;
  onEditingChange?: (editing: boolean) => void;
}

const ProfileTab: FC<ProfileTabProps> = ({
  user,
  editing,
  roleLabel,
  editTitle = EDIT_PROFILE_TITLE,
  onStartEdit,
  onUserUpdated,
  onEditingChange,
}) => {
  const classes = useStyles();
  const role = displayOrMissing(roleLabel);
  const firstname = displayOrMissing(user?.firstname);
  const lastname = displayOrMissing(user?.lastname);
  const email = displayOrMissing(user?.email);
  const roleId = readRole(user?.company_user_role)?.id;
  const manager = displayOrMissing(getManagerName(user));

  const handleSaved = async (updated?: any) => {
    await onUserUpdated(updated);
    onEditingChange?.(false);
  };

  const renderValue = (item: { text: string; missing: boolean }) => (
    <span className={clsx(classes.fieldValue, item.missing && classes.missing)}>{item.text}</span>
  );

  if (editing) {
    return (
      <div className={classes.card}>
        <h1 className={classes.editPageTitle}>{editTitle}</h1>
        <ProfileEditForm user={user} roleLabel={roleLabel} onSaved={handleSaved} />
      </div>
    );
  }

  return (
    <div className={classes.card}>
      <Button
        className={classes.editBtn}
        startIcon={<PencilSimpleIcon size={18} />}
        onClick={onStartEdit}>
        Éditer
      </Button>
      <div className={classes.fields}>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Rôle :</span>
          {renderValue(role)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Prénom :</span>
          {renderValue(firstname)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Nom :</span>
          {renderValue(lastname)}
        </div>
        <div className={classes.fieldRow}>
          <span className={classes.fieldLabel}>Mail :</span>
          {renderValue(email)}
        </div>
        {roleId !== DIRECTION_ROLE_ID && (
          <div className={classes.fieldRow}>
            <span className={classes.fieldLabel}>Administrateur de rattachement :</span>
            {renderValue(manager)}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileTab;
